import ClarityDefault from '@microsoft/clarity';
import { runtimeEnv } from '../../runtimeEnv';
import { deleteCookies } from '../consent/cookies';

// Rule 16: mask aggressively. The signup funnel touches auth — never capture form fields,
// identifying text, or tokens held in storage. Clarity + its SDK are injectable for tests.
type ClarityApi = {
  init: (id: string) => void;
  consent: (consent?: boolean) => void;
  stop: () => void;
  start: () => void;
};
type ClarityGlobal = { clarity?: (command: string, ...args: unknown[]) => void };
type ClearCookies = (names: string[]) => void;

// The npm wrapper exposes init/consent only. stop/start go through the tag's global queue,
// which clarity-js drains by command name; consent(false) alone keeps recording cookielessly.
const clarityApi: ClarityApi = {
  init: (id) => ClarityDefault.init(id),
  consent: (c) => ClarityDefault.consent(c),
  stop: () => (globalThis as unknown as ClarityGlobal).clarity?.('stop'),
  start: () => (globalThis as unknown as ClarityGlobal).clarity?.('start'),
};

let loaded = false; // the tag has been injected on this page
let started = false; // capture is running

export function initClarity(
  clarity: ClarityApi = clarityApi,
  projectId: string = runtimeEnv.clarityProjectId,
): void {
  if (!projectId || started) return;
  if (loaded) {
    clarity.start();
  } else {
    clarity.init(projectId);
    loaded = true;
  }
  clarity.consent(true);
  started = true;
}

// Withdraw: halt capture if running, and always clear the cookies — a prior cookieless run
// may have left `_clck` even when this session never started Clarity.
export function stopClarity(
  clarity: ClarityApi = clarityApi,
  clear: ClearCookies = deleteCookies,
): void {
  if (started) {
    clarity.consent(false);
    clarity.stop();
    started = false;
  }
  clear(['_clck', '_clsk']);
}
